import { render, staticRenderFns } from "./previewChapter.vue?vue&type=template&id=4de6c7e4&scoped=true&"
import script from "./previewChapter.vue?vue&type=script&lang=js&"
export * from "./previewChapter.vue?vue&type=script&lang=js&"
import style0 from "./previewChapter.vue?vue&type=style&index=0&id=4de6c7e4&prod&lang=less&scoped=true&"
import style1 from "./previewChapter.vue?vue&type=style&index=1&id=4de6c7e4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de6c7e4",
  null
  
)

export default component.exports